import { UserAppState } from "../../../enums/user-app-state";
import { AppStateActions } from "../../actions/actionCreators";
import {
  FETCH_USER_APP_STATE_REQUEST,
  FETCH_USER_APP_STATE_SUCCESS,
  FETCH_USER_APP_STATE_FAILURE,
} from "../../actions/actionTypes/userAppState";

interface AppStateState {
  userAppState: UserAppState | string | null;
  loading: boolean;
  error: string | null;
}

const initialState: AppStateState = {
  userAppState: UserAppState.PAYMENT_ONLY,
  loading: false,
  error: null,
};

export const userAppState = (state = initialState, action: AppStateActions): AppStateState => {
  switch (action.type) {
    case FETCH_USER_APP_STATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_USER_APP_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        userAppState: action.payload,
      };
    case FETCH_USER_APP_STATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
